import { render, staticRenderFns } from "./TriangleDiv.vue?vue&type=template&id=34d309ea&scoped=true&"
import script from "./TriangleDiv.vue?vue&type=script&lang=js&"
export * from "./TriangleDiv.vue?vue&type=script&lang=js&"
import style0 from "./TriangleDiv.vue?vue&type=style&index=0&id=34d309ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d309ea",
  null
  
)

export default component.exports